import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M56.9,50,82.3,22a5.9,5.9,0,0,0,0-7.7,4.6,4.6,0,0,0-6.9,0L50,42.3l-25.3-28a4.6,4.6,0,0,0-6.9,0,5.9,5.9,0,0,0,0,7.7L43.1,50,17.7,78a5.9,5.9,0,0,0,0,7.7,4.6,4.6,0,0,0,6.9,0L50,57.7l25.3,28a4.6,4.6,0,0,0,6.9,0,5.9,5.9,0,0,0,0-7.7Z" />,
);
